import Link from 'next/link'
import React from 'react'

import { useGetFilterValue } from '@/legacy-src/components/filters/hooks/useGetFilterValue'

import { getTranslate } from '../../utilities/i18n'
import Icon from '../icons/Icon'
import useInsuranceCompanies from './hooks/useInsuranceCompanies'

const InsuranceCompanyBanner: React.FC = () => {
  const { t } = getTranslate()

  const { insuranceCompanies } = useInsuranceCompanies()

  const selectedCompanies = useGetFilterValue('insurance')

  const existsBannerText = (): boolean => {
    return insuranceCompanies?.some((item) => item.bannerText && selectedCompanies.includes(item.id.toString()))
  }
  const getProperty = (id: string, property: string) => {
    const entity = insuranceCompanies?.find((item) => item.id.toString() === id)
    return entity ? entity[property] : ''
  }

  return existsBannerText() ? (
    <div className="mb-8 w-full">
      <div className="rounded-xl p-6 shadow-hedepy">
        {selectedCompanies.map((id) => {
          const bannerText = getProperty(id, 'bannerText')
          return (
            bannerText && (
              <div className="my-6 flex items-center" key={id}>
                <Icon icon="shield" color="primary" size="md" className="mr-4" />
                <div className="flex grow justify-between">
                  <div className="pr-3 text-xl font-bold">{bannerText}</div>
                  <div className="text-sm text-xl font-semibold uppercase text-primary">
                    <Link
                      href={getProperty(id, 'url')}
                      target="_blank"
                      className="hover:text-primary hover:no-underline"
                    >
                      {t('components.filter.insuranceBanner.how')} - {getProperty(id, 'name')}
                      <Icon icon="arrow" color="primary" size="sm" className="ml-4" />
                    </Link>
                  </div>
                </div>
              </div>
            )
          )
        })}
      </div>
    </div>
  ) : null
}

export default InsuranceCompanyBanner
